import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-xhm-s0-month",
  "use": "icon-soc-l1-xhm-s0-month-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-xhm-s0-month\">\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\n  <rect x=\"192\" y=\"256\" width=\"640\" height=\"544\" rx=\"48\" />\n  <path d=\"M192 416h640\" fill=\"#fff\" fill-opacity=\".35\" />\n  <path d=\"M320 192h64v128h-64zM640 192h64v128h-64z\" />\n  <path d=\"M352 560l96 96 192-192\" fill=\"none\" stroke=\"#fff\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-xhm-s0-month.svg
// module id = T+co
// module chunks = 488